import "antd/dist/reset.css";
import "./App.css";
import "./styles/ant-overrides.css"; // Global Ant Design overrides for z-index fixes
import Router from "./routers/Router";
import { Layout, Spin, ConfigProvider } from 'antd';
import Navbar from './Navbar';
import AdminNavbar from './AdminNavbar.js';
import { getCurrentUser } from "./apis";
import { useEffect, useState } from "react";
import { LoadingOutlined } from '@ant-design/icons';

import { Link } from "react-router-dom";
import logo from '../src/Assets/Logo.svg';
import logoExis from '../src/Assets/logonavbarexis.svg';
import LogRocket from "logrocket";
const { Header, Content } = Layout;

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [user, setUser] = useState(null);

  // ExisMobility Ant Design Theme Configuration
  const themeConfig = {
    token: {
      // Primary Colors
      colorPrimary: '#353A0A',
      colorPrimaryHover: '#4a5214',
      colorPrimaryActive: '#262b08',

      // Secondary/Success Colors  
      colorSuccess: '#A1E340',
      colorSuccessHover: '#b8e866',
      colorSuccessActive: '#8bc92e',

      // Accent Colors
      colorWarning: '#FF852B',
      colorError: '#ff4d4f',
      colorInfo: '#8C74FF',

      // Typography
      fontFamily: '"Inter", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", sans-serif',
      fontSize: 14,
      fontSizeHeading1: 48,
      fontSizeHeading2: 30,
      fontSizeHeading3: 24,
      fontSizeHeading4: 20,
      fontSizeHeading5: 16,

      // Border Radius
      borderRadius: 8,
      borderRadiusLG: 12,
      borderRadiusSM: 4,

      // Spacing
      padding: 16,
      paddingLG: 24,
      paddingSM: 8,
      margin: 16,
      marginLG: 24,
      marginSM: 8,
    },
    components: {
      Button: {
        colorPrimary: '#353A0A',
        algorithm: true,
      },
      Menu: {
        itemSelectedBg: 'rgba(53, 58, 10, 0.1)',
        itemSelectedColor: '#353A0A',
        itemHoverBg: 'rgba(53, 58, 10, 0.05)',
      },
      Layout: {
        siderBg: '#353A0A',
        headerBg: '#353A0A',
      },
      Input: {
        activeBorderColor: '#353A0A',
        hoverBorderColor: '#4a5214',
      },
      Select: {
        optionSelectedBg: 'rgba(53, 58, 10, 0.1)',
      },
    },
  };


  const checkAuth = async () => {
    setIsLoading(true);
    try {
      const response = await getCurrentUser();
      if (response) {
        setIsAuthenticated(true);
        setIsAdmin(response.is_admin);
        setUser(response);
        localStorage.setItem("user", JSON.stringify(response));
        LogRocket.identify(response.id, {
          name: response.first_name + " " + response.last_name,
          email: response.email,
        });
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      setIsAuthenticated(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    checkAuth();
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <div>
            <img src={logo} alt="Traffix Logo" className="loading-logo" />
          </div><Spin
            indicator={<LoadingOutlined className="loading-spinner" spin />}
            size="large"
          />
          <div className="loading-text">Loading Traffix...</div>
        </div>
      </div>
    );
  }
  {/**
        <Layout >
              <AdminNavbar />
              <Layout>
                <Content>
                  <Router isAuthenticated={isAuthenticated} isAdmin={isAdmin} user={user} />
                </Content>
              </Layout>
            </Layout>
  */}
  return (
    <ConfigProvider theme={themeConfig}>
      {isAuthenticated ? (
        <Layout className="app-layout">
          {isAdmin ? (
            // Admin Layout with Sidebar
            <Layout className="admin-layout">
              <AdminNavbar />
              <Layout className="admin-content-layout">
                <Content>
                  <Router isAuthenticated={isAuthenticated} isAdmin={isAdmin} user={user} />
                </Content>
              </Layout>
            </Layout>
          ) : (
            // Client Layout with Top Navbar
            // Client Layout with Top Navbar
            <>
              <Header className="client-header">
                <div className="header-content">
                  <div className="brand-logo">
                    <Link to="/">
                        <div className="logos-wrapper">
                       <img src={logoExis} alt="Exis Logo" className="logo-exis" />
                      </div>
                    </Link>
                  </div>
                  <Navbar user={user} />
                </div>
              </Header>
              <Content className="main-content client-main-content">
                <Router isAuthenticated={isAuthenticated} isAdmin={isAdmin} user={user} />
              </Content>
            </>
          )}
        </Layout>
      ) : (
        <div className="auth-layout">
          <Router isAuthenticated={isAuthenticated} isAdmin={isAdmin} user={user} />
        </div>
      )}
    </ConfigProvider>
  );
}

export default App;
